module.exports = __webpack_public_path__ + "img/Vector30.bdbf237e.svg";